import React from "react";
import { BiSearchAlt2 } from "react-icons/bi";
import { IconType } from "react-icons";
import ATMInputAdormant from "src/components/UI/atoms/formFields/ATMInputAdormant/ATMInputAdormant";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";

type CMSSideBarLayoutProps = {
  infoCard?: React.ReactNode;
  listData?: any[];
  loader?: boolean;
  searchValue: string;
  onSearch: (value: string) => void;
  onClickItem: (id: string) => void;
};

const CMSSideBarLayout = ({
  infoCard,
  listData,
  loader,   
  searchValue,
  onSearch,
  onClickItem,
}: CMSSideBarLayoutProps) => {
const location = useLocation();

  return (
    <div className="h-[calc(100vh-50px)] border-r">
      <div className="w-[250px] h-full flex flex-col">
        {/* Info Card */}
        <div>{infoCard}</div>

        {/* Search Bar */}
        {/* <div className="px-2 py-2 flex items-center justify-center">
          <ATMInputAdormant
            name=""
            value={searchValue}
            placeholder="Search here..."
            className="h-[40px] shadow-sm border-[1px]"
            adormant={<BiSearchAlt2 className="text-slate-400 text-xl " />}
            adormantProps={{
              position: "start",
              extraClasses: "bg-white border-0 ",
            }}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div> */}

        {/* List */}
        <div className="grow overflow-auto">
          {loader && (
            <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
              Loading...
            </div>
          )}
          <div className="px-[8px] flex flex-col min-w-[100%] overflow-y-auto">
            {listData?.map((ele: any) => {
              const isActive = location.pathname === `/cms/${ele.id}`;
              return (
                <div
                  key={ele?.id}
                  onClick={() => onClickItem(ele?.id)}
                  className={`shadow-sm mb-2 border-[1px] border-slate-100 rounded cursor-pointer relative ${
                    isActive ? "bg-blue-300" : "bg-white"
                  }`}
                >
                  <div className="p-2">
                    <Tooltip title={ele?.title}>
                      <h3 className="truncate text-md font-medium">
                        {ele?.title}
                      </h3>
                    </Tooltip>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CMSSideBarLayout;
